export const CASES = {
    UPDATE_TEMPLATES: 'UPDATE_TEMPLATES',
    UPDATE_TEMPLATES_FORM: 'UPDATE_TEMPLATES_FORM',
    CLEAR_TEMPLATES: 'CLEAR_TEMPLATES',
};
